import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RessourceSetting } from 'src/app/utils/interfaces/new/RessourceSetting';
import { EventReminder } from 'src/app/utils/interfaces/new/event-reminder';
import { SnackbarService } from '../snackbar/snackbar.service';

export const entreeDossierPatient = "entreeDossierPatient";
export const entreeConsultation = "entreeConsultation";
export const agePoidsOrdonnance = "agePoidsOrdonnance";
export const nombreBoitesOrdonnance = "nombreBoitesOrdonnance";
export const isDciDefault = "isDciDefault";
export const isOrdoSecu = "isOrdoSecu";
export const recurrenceSAM = "recurrenceSAM";
export const autoValidIdentite= "autoValidIdentite";
export const hideTabPatient = "hideTabPatient";
export const identiteOptionnelle = "identiteOptionnelle";
export const titleMaquetteToConsult = 'titleMaquetteToConsult';
export const email = "email";
export const nomServeurSmtp = "nomServeurSmtp";
export const nomServeurImap = "nomServeurImap";
export const nomUtilisateurMessagerie = "nomUtilisateurMessagerie";
export const passwordMessagerie = "passwordMessagerie";
export const authentificationSmtp = "authentificationSmtp";
export const identifiantSmtp = "identifiantSmtp";
export const passwordSmtp = "passwordSmtp";
export const portSmtp = "portSmtp";
export const typeAuthentication = "typeAuthentication";
export const resultatsHprim = "resultatsHprim";
export const mailSignature = 'mailSignature';
export const typeConsultMessagerie = 'typeConsultMessagerie';

export const isEprescriptionActive = 'isEprescriptionActive';
export const tracesEprescription = 'tracesEprescription';
export const tracesEprescriptionType = 'tracesEprescriptionType';
export const envoiTracesEprescription = 'envoiTracesEprescription';
export const askInfosPatientRule = 'askInfosPatientRule';
export const isSimpleSearchBCB = 'isSimpleSearchBCB';
export const AnalyseBeforePrint = 'AnalyseBeforePrint';
export const displayDateDebutPrise = 'displayDateDebutPrise';
export const choisirEntete = 'choisirEntete';
export const enTeteVideHauteur = 'enTeteVideHauteur';

// Remplacement ePrescription
export const isRemplacementActive = 'isRemplacementActive';
export const remplaceRPPS = 'remplaceRPPS';
export const remplaceStructure = 'remplacesStructure';
export const remplaceTypeStructure = 'remplaceTypeStructure';
export const remplaceStructureNumFacturation = 'remplaceStructureNumFacturation';

//FSE PREF
export const IDJFSE = 'IDJFSE';
export const isDesynchro = 'DESYNCHRO';
export const isCPX = 'CPX';
export const accidentDC = 'accidentDC';
export const parcoursSoins = 'parcoursSoins';
export const isRP = 'RP';
export const isTLA = 'TLA';

//préférences envoi document par mail
export const documentClass = 'documentClass';
export const documentType = 'documentType';
export const documentFormat = 'documentFormat';
// Le type d'activité est géré dans dmp.service.ts

//Paramètrage du lecteur de qr-code
export const scannerIsUsb = 'scannerIsUsb';
export const scannerIsCom = 'scannerIsCom';
@Injectable({
  providedIn: 'root'
})
export class RessourceService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders(),
    params: undefined
  };

  constructor(
    private _http: HttpClient,
    private _snack: SnackbarService
  ) { }

  public async getResourceSettings(resourceId: string, resourceType: string): Promise<Array<RessourceSetting>> {
    return new Promise<Array<RessourceSetting>>(async (resolve, reject) => {
      try {
        const res = await this._http.get<Array<RessourceSetting>>(`${environment.basePath}/user/resources/${resourceId}/type/${resourceType}/settings`, this.httpOptions).toPromise();
        resolve(res.body);
      } catch (e) {
        this._snack.openSnackBar(e.error.message);
        reject(e);
      }
    });
  }

  public async getSettingsList(resourceId: string, settingKey: string[], resourceType = 'profil'): Promise<Array<RessourceSetting>> {
    const body = {
      settingsKey: settingKey, // Obligatoire 0 si inconnu
    };
    this.httpOptions = {
      ...this.httpOptions,
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return new Promise<Array<RessourceSetting>>(async (resolve, reject) => {
      try {
        const res = await this._http.post<Array<RessourceSetting>>(`${environment.basePath}/user/resources/${resourceId}/type/${resourceType}/getSettingsList`,body, this.httpOptions).toPromise();
        resolve(res.body);
      } catch (e) {
        this._snack.openSnackBar(e.error.message);
        reject(e);
      }
    });
  }

  public async postResourceSettings(resourceId: string, resourceType: string, setting: RessourceSetting): Promise<RessourceSetting> {
    return new Promise<RessourceSetting>(async (resolve, reject) => {
      try {
        const res = await this._http.post<RessourceSetting>(`${environment.basePath}/user/resources/${resourceId}/type/${resourceType}/settings`, setting, this.httpOptions).toPromise();
        resolve(res.body);
      } catch (e) {
        this._snack.openSnackBar(e.error.message);
        reject(e);
      }
    });
  }

  public getSettingFromArray(settings: Array<RessourceSetting>, settingKey: string): {
    value: string | undefined, type: string | undefined
  }
    | undefined {
    const setting = settings.find((s) => s.settingKey === settingKey);

    if (setting) {
      return {
        value: setting.settingValue,
        type: setting.settingType
      };
    } else {
      return undefined;
    }
  }

  public async getRemindParameters(resourceId: string, resourceType: string): Promise<EventReminder> {
    return new Promise<EventReminder>(async (resolve, reject) => {
      try {
        this.httpOptions.params = undefined;
        const res = await this._http.get<EventReminder>(`${environment.basePath}/agenda/remind/${resourceId}/type/${resourceType}`, this.httpOptions).toPromise();
        resolve(res.body);
      } catch (e) {
        this._snack.openSnackBar(e.error.message);
        reject(e);
      }
    });
  }

  public async updateRemindParameters(resourceId: string, resourceType: string, remind: EventReminder): Promise<EventReminder> {
    return new Promise<EventReminder>(async (resolve, reject) => {
      try {
        this.httpOptions.params = undefined;
        const res = await this._http.post<EventReminder>(`${environment.basePath}/agenda/remind/${resourceId}/type/${resourceType}`, remind, this.httpOptions).toPromise();
        resolve(res.body);
      } catch (e) {
        this._snack.openSnackBar(e.error.message);
        reject(e);
      }
    });
  }

  public async getRessourceByKeyValue(settingKey: string,settingValue: string, resourceType = 'profil'): Promise<Array<RessourceSetting>> {
    const body = {
      settingKey: settingKey,
      settingValue: settingValue,
    };
    const httpOptions = {
      ...this.httpOptions,
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return new Promise<Array<RessourceSetting>>(async (resolve, reject) => {
      try {
        const res = await this._http.post<Array<RessourceSetting>>(`${environment.basePath}/user/resources/type/${resourceType}/getRessourceByKeyValue`,body, httpOptions).toPromise();
        resolve(res.body);
      } catch (e) {
        this._snack.openSnackBar(e.error.message);
        reject(e);
      }
    });
  }

  public async deleteSetting(resourceId: string,settingKey: string,resourceType: 'ressource' | 'profil' | 'cabinet' = 'profil'): Promise<void> {
  const httpOptions = {
    ...this.httpOptions,
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  const url =
    `${environment.basePath}/user/resources/` +
    `${encodeURIComponent(resourceId)}/type/` +
    `${encodeURIComponent(resourceType)}/settings/` +
    `${encodeURIComponent(settingKey)}`;

  try {
    await this._http.delete<void>(url, httpOptions).toPromise();
  } catch (e) {
    this._snack.openSnackBar(
      e?.error?.message || 'Erreur lors de la suppression du paramètre'
    );
    throw e;
  }
}

}
